import { useTranslation } from "react-i18next"

const ElegirMode = ({ title, setMode, alAzarCallback = null }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="title">{title}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex flex-rowd-flex flex-row justify-content-center justify">
          <div className="col-lg-4 col-6 py-1">
            <div className="box category" onClick={() => setMode("manual")}>
              <span>{t(`ui.games.btns.set_up_your_game`)}</span>
            </div>
          </div>

          {alAzarCallback && (
            <>
              <div className="col-lg-4 col-6 py-1">
                <div className="box category azaroso" onClick={alAzarCallback}>
                  <span>{t(`ui.games.btns.quickstart`)}</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export { ElegirMode }
